(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5978],{

/***/ 62663:
/***/ (function(module) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ 49029:
/***/ (function(module) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),

/***/ 18674:
/***/ (function(module) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ 35393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayReduce = __webpack_require__(62663),
    deburr = __webpack_require__(53816),
    words = __webpack_require__(58748);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),

/***/ 69389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(18674);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),

/***/ 93157:
/***/ (function(module) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),

/***/ 2757:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),

/***/ 53816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var deburrLetter = __webpack_require__(69389),
    toString = __webpack_require__(79833);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),

/***/ 18029:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCompounder = __webpack_require__(35393),
    upperFirst = __webpack_require__(11700);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),

/***/ 58748:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiWords = __webpack_require__(49029),
    hasUnicodeWord = __webpack_require__(93157),
    toString = __webpack_require__(79833),
    unicodeWords = __webpack_require__(2757);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),

/***/ 19931:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-and-conditions",
      function () {
        return __webpack_require__(9547);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _MainLayout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _MainLayout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33509);



/***/ }),

/***/ 9547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_instantwire; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/lodash/startCase.js
var startCase = __webpack_require__(18029);
var startCase_default = /*#__PURE__*/__webpack_require__.n(startCase);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/terms_and_conditions/styles.ts

function _templateObject() {
    const data = _taggedTemplateLiteral([
        '\n  li:before {\n    content: "- ";\n  }\n  li {\n    margin-top: 4px;\n  }\n'
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const DashedUl = emotion_styled_browser_esm/* default.ul */.Z.ul(_templateObject());

;// CONCATENATED MODULE: ./src/components/terms_and_conditions/TermsAndConditionsEn.tsx






const TermsAndConditionsEn = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 2,
        className: "pb-16 pt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                fontSize: "2rem",
                variant: "h1",
                children: "Terms and Conditions"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                fontSize: "0.875rem",
                fontStyle: "italic",
                children: "Last Updated: July 14, 2023"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                children: [
                    "These Terms of Service (the “Agreement”) explains the terms and conditions by which you may access and use \xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/",
                        children: "https://nemo.renec.org/"
                    }),
                    "\xa0 and any subdomains associated with the Website. You must read this Agreement carefully as it governs your use of the Website. By accessing or using the Website, you signify that you have read, understand, and agree to be bound by this Agreement in its entirety. If you do not agree, you are not authorized to access or use the Website and should not use the Website."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "These terms of use, together with any documents and additional terms they expressly incorporate by reference, which includes any other terms and conditions or other agreement that ",
                            startCase_default()(constants/* NETWORK_CHAIN */.sb),
                            " Foundation UAB and its affiliates (“",
                            startCase_default()(constants/* NETWORK_CHAIN */.sb),
                            "/",
                            constants/* PRODUCT_NAME */.sG,
                            " Swap/ ",
                            constants/* PRODUCT_NAME */.sG,
                            ",” “we,” “us” and “our”) posts publicly or makes available to you or the company or other legal entity you represent (“you” or “your”) (collectively, these “Terms”), are entered into between ",
                            constants/* PRODUCT_NAME */.sG,
                            " and you concerning your use of, and access to ",
                            constants/* PRODUCT_NAME */.sG,
                            "’s websites; web applications; mobile applications; and all associated sites linked thereto by ",
                            constants/* PRODUCT_NAME */.sG,
                            " (collectively with any materials and services available therein, and successor website(s) or application(s) thereto, the “Site”);"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "Please read these Terms carefully, as these Terms govern your use of the Services. These Terms expressly cover your rights and obligations, and our disclaimers and limitations of legal liability, relating to your use of, and access to, the Services. By using our services, acknowledging these Terms by other means, or otherwise accessing or using the Services, you accept and agree to be bound by and to comply with these Terms, including the mandatory arbitration provision in Section 17. If you do not agree to these Terms, then you must not access or use the Services."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                fontWeight: 600,
                                display: "inline",
                                children: [
                                    "Please carefully review the disclosures and disclaimers set forth in their entirety before using any software developed by ",
                                    constants/* PRODUCT_NAME */.sG,
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                children: [
                                    "The information in Section 14 provides important details about the legal obligations associated with your use of the Services. By accessing or using the Services, you agree that ",
                                    constants/* PRODUCT_NAME */.sG,
                                    " does not provide execution, settlement, or clearing services of any kind and is not responsible for the execution, settlement, or clearing of transactions automated through the Services."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontWeight: 600,
                        children: "NOTICE: This Agreement contains important information, including a binding arbitration provision and a class action waiver, both of which impact your rights as to how disputes are resolved. The Website is only available to you — and you should only access the Website — if you agree completely with these terms."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "1. MODIFICATIONS TO THESE TERMS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                children: "We reserve the right, in our sole discretion, to modify these Terms from time to time. If we make changes, we will provide you with notice of such changes, such as by providing notice through the Services or updating the “Last Updated” date at the top of these Terms. Unless we state otherwise in our notice, all modifications will be effective when they are posted, and your continued accessing or use of the Website will serve as confirmation of your acceptance of those modifications. If you do not agree with any modifications to this Agreement, you must immediately stop accessing and using the Website."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "2. USE OF SERVICES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                children: [
                    "2.1 As a condition to accessing or using the Services, you represent and warrant to ",
                    constants/* PRODUCT_NAME */.sG,
                    " the following:"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DashedUl, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "To access or use the Website, you must be able to form a legally binding contract with us. Accordingly, you represent that you are at least the age of majority in your jurisdiction (e.g., 18 years old in the United States) and have the full right, power, and authority to enter into and comply with the terms and conditions of this Agreement on behalf of yourself and any company or legal entity for which you may access or use the Website."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "You further represent that you are not (a) the subject of economic or trade sanctions administered or enforced by any governmental authority or otherwise designated on any list of prohibited or restricted parties (including but not limited to the list maintained by the United Nations, European Commission  Office of Foreign Assets Control of the U.S. Department of the Treasury,) or (b) a citizen, resident, or organized in a jurisdiction or territory that is the subject of comprehensive country-wide, territory-wide, or regional economic sanctions by the United Nations, European Commission  Office of Foreign Assets Control of the U.S. Department of the Treasury"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "you do not, and will not, use a VPN or any other privacy or anonymization tools or techniques to circumvent, or attempt to circumvent, any restrictions that apply to the Services; and"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "your access to the Services (a) is not prohibited by and does not otherwise violate or assist you to violate any domestic or foreign law, rule, statute, regulation, by-law, order, protocol, code, decree, or another directive, requirement, or guideline, published or in force that applies to or is otherwise intended to govern or regulate any person, property, transaction, activity, event or other matter, including any rule, order, judgment, directive or other requirement or guideline issued by any domestic or foreign federal, provincial or state, municipal, local or other governmental, regulatory, judicial or administrative authority having jurisdiction over ",
                            constants/* PRODUCT_NAME */.sG,
                            ", you, the Services, or as otherwise duly enacted, enforceable by law, the common law or equity (collectively, “Applicable Laws”); and (b) does not contribute to or facilitate any illegal activity."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                children: "2.2 As a condition to accessing or using the Services, you acknowledge, understand, and agree to the following:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DashedUl, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "From time to time, the Services may be inaccessible or inoperable for any reason, including: (a) equipment or technology or other infrastructure delay, inaccessibility, or malfunctions; (b) periodic maintenance procedures or repairs that ",
                            constants/* PRODUCT_NAME */.sG,
                            " or any of our suppliers or contractors may undertake from time to time; (c) causes beyond ",
                            constants/* PRODUCT_NAME */.sG,
                            "’s control or that ",
                            constants/* PRODUCT_NAME */.sG,
                            " could not reasonably foresee; (d) disruptions and temporary or permanent unavailability of underlying blockchain infrastructure; or (e) unavailability of third-party service providers or external partners for any reason. Without limitation of any other provision of these Terms, and as set forth below, ",
                            constants/* PRODUCT_NAME */.sG,
                            " has no responsibility or liability for any losses or other injuries resulting from any such events;"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "We reserve the right to disable or modify access to the Services (such as restricting features of the Services) at any time in the event of any breach of these Terms, including, if we reasonably believe any of your representations and warranties may be untrue, misleading, or inaccurate, and we will not be liable to you for any losses or damages you may suffer as a result of or in connection with the Services being inaccessible to you at any time or for any reason; the Services may evolve, which means ",
                            constants/* PRODUCT_NAME */.sG,
                            " may apply changes, replace, or discontinue (temporarily or permanently) the Services at any time in our sole discretion;"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "the pricing information and other data provided on the Site does not represent (i) an offer, a solicitation of an offer, or recommendation to enter into, a transaction with ",
                            constants/* PRODUCT_NAME */.sG,
                            " (other than the payment of fees to ",
                            constants/* PRODUCT_NAME */.sG,
                            ") or (ii) any advice regarding a transaction entered into using the Site and the Services;"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            constants/* PRODUCT_NAME */.sG,
                            " does not act as an agent for you or any other user of the Services;"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "you are solely responsible for your use of the Services, including all of your transfers of Digital Assets;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "to the fullest extent not prohibited by Applicable Law, we owe no fiduciary duties or liabilities to you or any other party, and that to the extent any such duties or liabilities may exist at law or in equity, you hereby irrevocably disclaim, waive, and eliminate those duties and liabilities;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "we have no control over, or liability for, the delivery, quality, safety, legality, or any other aspect of any Digital Assets that you may transfer to or from a third party, and we are not responsible for ensuring that an entity with whom you transact completes the transaction or is authorized to do so, and if you experience a problem with any transactions in Digital Assets using the Services, then you bear the entire risk;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "we may, from time to time, operate contests, promotions, sweepstakes or other activities or offer referral programs (“Promotions and Referrals”), which may be governed by separate terms and conditions and rules that may contain certain eligibility requirements; and you are responsible for reading all terms and conditions and rules relating to the Promotions and Referrals to determine whether you are eligible to participate; if you enter or participate in any Promotions and Referrals, then you agree to abide by and to comply with all terms and conditions and rules of such Promotions and Referrals; all Promotions and Referrals will be optional so you should not enter or participate in such Promotions and Referrals if you do not agree to abide by and comply with all such terms and conditions and rules; and"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            "if you receive discounts on fees from any Promotions and Referrals that are not subject to separate terms and conditions and rules, then ",
                            constants/* PRODUCT_NAME */.sG,
                            " reserves the right to add to, modify or eliminate the discounts and any other aspect of such Promotions and Referrals."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                children: "2.3 As a condition to accessing or using the Services, you acknowledge, understand, and agree to the following:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DashedUl, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "in connection with using the Services, you only will transfer legally-obtained Digital Assets that belong to you;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "you will obey all Applicable Laws in connection with using the Services, and you will not use the Services if the laws of your country, or any other Applicable Law, prohibit you from doing so;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "any Digital Assets you use in connection with the Services are either owned by you or you are validly authorized to carry out actions using such Digital Assets; and"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "in addition to complying with all restrictions, prohibitions, and other provisions of these Terms, you will (a) ensure that, at all times, all information that you provide on the Site and during your use of the Services is current, complete, and accurate; and (b) maintain the security and confidentiality of your private keys and other related credentials."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "3. FEES AND PRICE ESTIMATES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                children: [
                    "In connection with your use of the Services, unless expressly stated otherwise pursuant to a promotion operated by ",
                    constants/* PRODUCT_NAME */.sG,
                    ", you are required to pay all fees necessary for interacting with the ",
                    startCase_default()(constants/* NETWORK_CHAIN */.sb),
                    " blockchain, including “gas” costs, as well as all other fees reflected on the Site at the time of your use of the Services. Although we attempt to provide accurate fee information, this information reflects our estimates of fees, which may vary from the actual fees paid to use the Services and interact with the ",
                    startCase_default()(constants/* NETWORK_CHAIN */.sb),
                    " blockchain."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "4. NO PROFESSIONAL ADVICE OR FIDUCIARY DUTIES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                children: "All information provided in connection with your access and use of the Services is for informational purposes only and should not be construed as professional advice. You should not take, or refrain from taking any action based on any information contained on the Site or any other information that we make available at any time, including blog posts, data, articles, links to third-party content, discord content, news feeds, tutorials, tweets, and videos. Before you make any financial, legal, or other decisions involving the Services, you should seek independent professional advice from an individual who is licensed and qualified in the area for which such advice would be appropriate. The Terms are not intended to, and do not, create or impose any fiduciary duties on us. You further agree that the only duties and obligations that we owe you are those set out expressly in these Terms."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "5. PROHIBITED ACTIVITY"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "5.1 You may not use the Services to engage in the categories of activity set forth below (“Prohibited Uses”). The specific activities set forth below are representative, but not exhaustive, of Prohibited Uses. You agree not to engage in, or attempt to engage in, any of the following categories of prohibited activity in relation to your access and use of the Website:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DashedUl, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Intellectual Property Infringement. Activity that infringes on or violates any copyright, trademark, service mark, patent, right of publicity, right of privacy, or other proprietary or intellectual property rights under the law."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Cyber Attack. Activity that seeks to interfere with or compromise the integrity, security, or proper functioning of any computer, server, network, personal device, or other information technology system, including (but not limited to) the deployment of viruses and denial of service attacks."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Fraud and Misrepresentation. Activity that seeks to defraud us or any other person or entity, including (but not limited to) providing any false, inaccurate, or misleading information in order to unlawfully obtain the property of another."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Market Manipulation. Activity that violates any applicable law, rule, or regulation concerning the integrity of trading markets, including (but not limited to) the manipulative tactics commonly known as “rug pulls”, pumping and dumping, and wash trading."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Securities and Derivatives Violations. Activity that violates any applicable law, rule, or regulation concerning the trading of securities or derivatives, including (but not limited to) the unregistered offering of securities and the offering of leveraged and margin commodity products to retail customers in the United States."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Sale of Stolen Property. Buying, selling, or transferring of stolen items, fraudulently obtained items, items taken without authorization, and/or any other illegally obtained items."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Data Mining or Scraping. Activity that involves data mining, robots, scraping, or similar data gathering or extraction methods of content or information from the Website."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Objectionable Content. Activity that involves soliciting information from anyone under the age of 18 or that is otherwise harmful, threatening, abusive, harassing, tortious, excessively violent, defamatory, vulgar, obscene, pornographic, libelous, invasive of another’s privacy, hateful, discriminatory, or otherwise objectionable."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Any Other Unlawful Conduct. Activity that violates any applicable law, rule, or regulation of the United States or another relevant jurisdiction, including (but not limited to) the restrictions and regulatory requirements imposed in applicable jurisdictions."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "5.2 In the event that we learn or reasonably suspect, in our sole discretion, that your account is or may be associated with any of the Prohibited uses as set forth above, we will consider it to be a violation of these Terms and may suspend or terminate your account, and/or block transactions or freeze your funds immediately without notice, and we reserve the right to report any such suspected or actual Prohibited uses to competent authority in applicable jurisdictions."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "6. USER RIGHTS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                children: [
                    "You hereby grant to us a royalty-free, fully paid-up, sublicensable (through multiple tiers), transferable, perpetual, irrevocable, non-exclusive, worldwide license to use, copy, modify, create derivative works of, display, perform, publish and distribute, in any form, medium or manner, any content that is available to other users as a result of your use of the Site or the Services (collectively, “Your Content”), including for promoting ",
                    constants/* PRODUCT_NAME */.sG,
                    " or the Services. You represent and warrant that (a) you own Your Content or have the right to grant the rights and licenses in these Terms; and (b) Your Content and our use of Your Content, as licensed herein, does not and will not violate, misappropriate or infringe on any third party’s rights."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "7. PROPRIETARY RIGHTS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "7.1 Excluding third-party software that the Services incorporates, as between you and ",
                            constants/* PRODUCT_NAME */.sG,
                            ", ",
                            constants/* PRODUCT_NAME */.sG,
                            " owns the Services, including all technology, content and other materials used, displayed or provided on the Site or in connection with the Services, and hereby grants you a limited, non-exclusive, revocable, non-transferable, non-sublicensable license to access and use those portions of the Site and the Services that are proprietary to ",
                            constants/* PRODUCT_NAME */.sG,
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "7.2 Any of ",
                            constants/* PRODUCT_NAME */.sG,
                            "’s product or service names, logos, and other marks used on the Site or as a part of the Services including ",
                            constants/* PRODUCT_NAME */.sG,
                            "’s name and logo are trademarks owned by ",
                            constants/* PRODUCT_NAME */.sG,
                            " or our licensors You may not copy, imitate, or use them without the prior written consent of ",
                            constants/* PRODUCT_NAME */.sG,
                            " or the applicable licensors, and these Terms do not grant you any rights in those trademarks. You may not remove, obscure, or alter any legal notices displayed in or along with the Site or the Services."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "7.3 The Website is a purely non-custodial application, meaning we do not ever have custody, possession, or control of your digital assets at any time. It further means you are solely responsible for the custody of the cryptographic private keys to the digital asset wallets you hold and you should never share your wallet credentials or seed phrase with anyone. We accept no responsibility for, or liability to you, in connection with your use of a wallet and make no representations or warranties regarding how the Website will operate with any specific wallet. Likewise, you are solely responsible for any associated wallet and we are not liable for any acts or omissions by you in connection with or as a result of your wallet being compromised."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "7.4 This Agreement is not intended to, and does not, create or impose any fiduciary duties on us. To the fullest extent permitted by law, you acknowledge and agree that we owe no fiduciary duties or liabilities to you or any other party, and that to the extent any such duties or liabilities may exist at law or in equity, those duties and liabilities are hereby irrevocably disclaimed, waived, and eliminated. You further agree that the only duties and obligations that we owe you are those set out expressly in this Agreement"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "8. LINKS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                children: [
                    "The Services or third parties may provide links to other World Wide Web or accessible sites, applications, or resources. You acknowledge and agree that ",
                    constants/* PRODUCT_NAME */.sG,
                    " is not responsible for the availability of such external sites, applications or resources, and does not endorse and is not responsible or liable for any content, advertising, products, or other materials on or available from such sites or resources. You further acknowledge and agree that Company will not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods, or services available on or through any such site or resource."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "9. COMPLIANCE AND TAX OBLIGATIONS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "9.1 The Website may not be available or appropriate for use in your jurisdiction. By accessing or using the Website, you agree that you are solely and entirely responsible for compliance with all laws and regulations that may apply to you."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "9.2 Specifically, your use of the Website or the services may result in various tax consequences, such as income or capital gains tax, value-added tax, goods and services tax, or sales tax in certain jurisdictions. It is your responsibility to determine whether taxes apply to any transactions you initiate or receive and, if so, to report and/or remit the correct tax to the appropriate tax authority."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "10 NO INVESTMENT ADVICE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "10.1 You agree and understand that: (a) all trades you submit through the Website are considered unsolicited, which means that they are solely initiated by you; (b) you have not received any investment advice from us in connection with any trades; and (c) we do not conduct a suitability review of any trades you submit."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "10.2 All such information provided by the Website is for informational purposes only and should not be construed as investment advice or a recommendation that a particular token is a safe or sound investment. You should not take, or refrain from taking, any action based on any information contained in the Website. By providing token information for your convenience, we do not make any investment recommendations to you or opine on the merits of any transaction or opportunity. You alone are responsible for determining whether any investment, investment strategy or related transaction is appropriate for you based on your personal investment objectives, financial circumstances, and risk tolerance."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "11. MODIFICATION, SUSPENSION, AND TERMINATION"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                children: "We may, at our sole discretion, from time to time and with or without prior notice to you, modify, suspend or disable (temporarily or permanently) the Services, in whole or in part, for any reason whatsoever. Upon termination of your access, your right to use the Services will immediately cease. We will not be liable for any losses suffered by you resulting from any modification to any Services or from any modification, suspension or termination, for any reason, of your access to all or any portion of the Services. The following sections of these Terms will survive any termination of your access to the Site or the Services, regardless of the reasons for its expiration or termination, in addition to any other provision which by law or by its nature should survive: Section 7 and Sections 11 through Section 19."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "12. RISKS DISCLOSURE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "12.1 This Clause provides Users with information about the risks associated with trading in Digital Assets and any other Services provided by ",
                            constants/* PRODUCT_NAME */.sG,
                            ". Users should ensure that their decisions are made on a well-informed basis, and they should undertake their own assessment as to the suitability of trading in Digital Assets in the light of their experience, objectives, financial resources and their specific needs and requirements."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "12.2 By accessing to use our services, a User is deemed to have reviewed, understood and accepted the risks associated with the Services provided by us."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "12.3 The market for Digital Assets is very new and rapidly developing and the risks of trading such assets are not fully understood. This Clause does not explain all of the risks or how such risks relate to your personal circumstances. It is important that you fully understand the risks involved before making a decision to use our Services."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "13. INDEMNIFICATION"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                children: [
                    "You will defend, indemnify, and hold harmless ",
                    constants/* PRODUCT_NAME */.sG,
                    " and our Representatives (collectively, “Indemnified Parties”) from any claim, demand, lawsuit, action, proceeding, investigation, liability, damage, loss, cost or expense, including reasonable attorneys’ fees, arising out of or relating to (a) your use of, or conduct in connection with the Services; (b) Digital Assets associated with your address; (c) any feedback or user content you provide to ",
                    constants/* PRODUCT_NAME */.sG,
                    ", if any, concerning the Services; (d) your violation of these Terms; or (e) your infringement or misappropriation of the rights of any other person or entity. If you are obligated to indemnify any Indemnified Party, ",
                    constants/* PRODUCT_NAME */.sG,
                    " (or, at our sole discretion, the applicable Indemnified Party) will have the right, in our or its sole discretion, to control any action or proceeding and to determine whether ",
                    constants/* PRODUCT_NAME */.sG,
                    " wishes to settle, and if so, on what terms, and you agree to cooperate with ",
                    constants/* PRODUCT_NAME */.sG,
                    " in the defense."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "14. DISCLOSURES; DISCLAIMERS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "14.1 ",
                            constants/* PRODUCT_NAME */.sG,
                            " is a developer of software and does not operate a Digital Asset or derivatives exchange platform or offer trade execution or clearing services and has no oversight, involvement, or control concerning your transactions using the Services. All transactions between users of the Interface are executed peer-to-peer directly between the users’ addresses through a smart contract. You are responsible for complying with all Applicable Laws that govern your Digital Assets."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "14.2 You understand that ",
                            constants/* PRODUCT_NAME */.sG,
                            " is not registered or licensed by any regulatory agency or authority. No such agency or authority has reviewed or approved the use of the Services. Any references in the Website to “best price” do not constitute a representation or warranty about pricing available through the Website, or elsewhere."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "14.3 To the maximum extent permitted under Applicable Law, the Services (and any of their content or functionality) provided by or on behalf of us are provided on an “AS IS” and “AS AVAILABLE” basis, and we expressly disclaim, and you hereby waive, any representations, conditions or warranties of any kind, whether express or implied, legal, statutory or otherwise, or arising from statute, otherwise in law, course of dealing, or usage of trade, including the implied or legal warranties and conditions of merchantability, merchantable quality, quality or fitness for a particular purpose, title, security, availability, reliability, accuracy, quiet enjoyment and non-infringement of third party rights. Without limiting the foregoing, we do not represent or warrant that the Services (including any data relating thereto) will be uninterrupted, available at any particular time, or error-free. Further, we do not warrant that errors in the Services are correctable or will be correctable."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "14.4 You acknowledge that data you provide while accessing or using the Services may become irretrievably lost or corrupted or temporarily unavailable due to a variety of causes, and agree that, to the maximum extent permitted under Applicable Law, we will not be liable for any loss or damage caused by denial-of-service attacks, software failures, viruses or other technologically harmful materials (including those which may infect your computer equipment), protocol changes by third-party providers, Internet outages, force majeure events or other disasters, scheduled or unscheduled maintenance, or other causes either within or outside of our control."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "15. LIMITATION OF DAMAGES; EXCLUSION OF CONSEQUENTIAL AND RELATED DAMAGES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "15.1 Without limitation of any other provision of these Terms, you hereby agree that neither ",
                            constants/* PRODUCT_NAME */.sG,
                            " nor any of its Representatives will have any responsibility or liability whatsoever for any loss or injury sustained by you or any third parties as a result of (i) any equipment or technology or other infrastructure delay, inaccessibility, or malfunctions; (ii) periodic maintenance procedures or repairs that ",
                            constants/* PRODUCT_NAME */.sG,
                            " or any of our suppliers or contractors may undertake from time to time; (iii) causes beyond ",
                            constants/* PRODUCT_NAME */.sG,
                            "’s control or that ",
                            constants/* PRODUCT_NAME */.sG,
                            " could not reasonably foresee; (iv) disruptions and temporary or permanent unavailability of underlying blockchain infrastructure; or (v) unavailability of third-party service providers or external partners for any reason. Under no circumstances will ",
                            constants/* PRODUCT_NAME */.sG,
                            " or its Representatives have any liability for any such loss or injury caused by any of the foregoing events, including but not limited to any obligation to cover or reimburse any damages or losses caused by such events. You expressly acknowledge that any risk of loss resulting from such events shall be borne by you, and you expressly assume any and all such risks."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "15.2 In no event will ",
                            constants/* PRODUCT_NAME */.sG,
                            ", our suppliers and contractors, and ",
                            constants/* PRODUCT_NAME */.sG,
                            "’s or our suppliers’ and contractors’ respective stockholders, members, directors, officers, managers, employees, attorneys, agents, representatives, suppliers and contractors (collectively, the “Risk Limited Parties”) be liable for any incidental, indirect, special, punitive, consequential or similar damages or liabilities whatsoever (including damages for loss of fiat, assets, data, information, revenue, opportunities, use, goodwill, profits or other business or financial benefit) arising out of or in connection with the Services (and any of their content and functionality), any execution or settlement of a transaction, any performance or non-performance of the Services, your Digital Assets, or any other product, service or other item provided by or on behalf of ",
                            constants/* PRODUCT_NAME */.sG,
                            ", whether under contract, tort (including negligence), civil liability statute strict liability breach of warranties or under any other theory of liability and whether or not we have been advised of, knew of or should have known of the possibility of such damages and, notwithstanding any failure of the essential purpose of these Terms or any limited remedy hereunder, nor is ",
                            constants/* PRODUCT_NAME */.sG,
                            " in any way responsible for the execution or settlement of transactions between users of the Services."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "16. LIMITATION OF LIABILITY"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "UNDER NO CIRCUMSTANCES SHALL WE OR ANY OF OUR OFFICERS, DIRECTORS, EMPLOYEES, CONTRACTORS, AGENTS, AFFILIATES, OR SUBSIDIARIES BE LIABLE TO YOU FOR ANY INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING (BUT NOT LIMITED TO) DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA, OR OTHER INTANGIBLE PROPERTY, ARISING OUT OF OR RELATING TO ANY ACCESS OR USE OF THE INTERFACE, NOR WILL WE BE RESPONSIBLE FOR ANY DAMAGE, LOSS, OR INJURY RESULTING FROM HACKING, TAMPERING, OR OTHER UNAUTHORIZED ACCESS OR USE OF THE INTERFACE OR THE INFORMATION CONTAINED WITHIN IT. WE ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY: (A) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT; (B) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM ANY ACCESS OR USE OF THE INTERFACE; (C) UNAUTHORIZED ACCESS OR USE OF ANY SECURE SERVER OR DATABASE IN OUR CONTROL, OR THE USE OF ANY INFORMATION OR DATA STORED THEREIN; (D) INTERRUPTION OR CESSATION OF FUNCTION RELATED TO THE INTERFACE; (E) BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE THAT MAY BE TRANSMITTED TO OR THROUGH THE INTERFACE; (F) ERRORS OR OMISSIONS IN, OR LOSS OR DAMAGE INCURRED AS A RESULT OF THE USE OF, ANY CONTENT MADE AVAILABLE THROUGH THE INTERFACE; AND (G) THE DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT OF ANY THIRD PARTY."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "15.2 In no event will ",
                            constants/* PRODUCT_NAME */.sG,
                            ", our suppliers and contractors, and ",
                            constants/* PRODUCT_NAME */.sG,
                            "’s or our suppliers’ and contractors’ respective stockholders, members, directors, officers, managers, employees, attorneys, agents, representatives, suppliers and contractors (collectively, the “Risk Limited Parties”) be liable for any incidental, indirect, special, punitive, consequential or similar damages or liabilities whatsoever (including damages for loss of fiat, assets, data, information, revenue, opportunities, use, goodwill, profits or other business or financial benefit) arising out of or in connection with the Services (and any of their content and functionality), any execution or settlement of a transaction, any performance or non-performance of the Services, your Digital Assets, or any other product, service or other item provided by or on behalf of ",
                            constants/* PRODUCT_NAME */.sG,
                            ", whether under contract, tort (including negligence), civil liability statute strict liability breach of warranties or under any other theory of liability and whether or not we have been advised of, knew of or should have known of the possibility of such damages and, notwithstanding any failure of the essential purpose of these Terms or any limited remedy hereunder, nor is ",
                            constants/* PRODUCT_NAME */.sG,
                            " in any way responsible for the execution or settlement of transactions between users of the Services."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "17. DISPUTE RESOLUTION AND ARBITRATION"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "PLEASE READ THE FOLLOWING SECTION CAREFULLY BECAUSE IT MAY SIGNIFICANTLY IMPACT YOUR LEGAL RIGHTS, INCLUDING YOUR RIGHT TO BRING A LAWSUIT AGAINST ",
                            constants/* PRODUCT_NAME */.sG,
                            " IN ANY COURT OR GOVERNING AUTHORITY. EXCEPT AS EXPRESSLY PROVIDED BELOW, THIS SECTION REQUIRES YOU TO SUBMIT ANY DISPUTE, CLAIM, OR DISAGREEMENT (EACH A “DISPUTE”) ARISING OUT OF THESE TERMS OR THE SERVICES, INCLUDING ANY DISPUTE THAT AROSE BEFORE THE EFFECTIVE DATES OF THESE TERMS, TO BINDING INDIVIDUAL ARBITRATION. THIS SECTION EXTENDS TO DISPUTES THAT AROSE OR INVOLVE FACTS OCCURING BEFORE THE EXISTENCE OF THIS OR ANY PRIOR VERSIONS OF THE TERMS AS WELL AS DISPUTES THAT MAY ARISE AFTER THE TERMINATION OF THE TERMS."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "17.1 You and ",
                            constants/* PRODUCT_NAME */.sG,
                            " agree that any Dispute arising out of or related to these Terms or the Services is personal to you and ",
                            constants/* PRODUCT_NAME */.sG,
                            " and that any Dispute will be resolved solely through individual arbitration, and will not be brought as a class arbitration, class action, or any other type of representative proceeding."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "17.2 You and ",
                            constants/* PRODUCT_NAME */.sG,
                            " waive your rights to a judge or jury trial or to have any Dispute arising out of or related to these Terms or the Services resolved in court. Instead, for any Dispute that you have against ",
                            constants/* PRODUCT_NAME */.sG,
                            " or relating in any way to the Services, you agree to first contact ",
                            constants/* PRODUCT_NAME */.sG,
                            " and attempt to resolve the claim informally by sending a written notice of your claim (“Notice”) to ",
                            constants/* PRODUCT_NAME */.sG,
                            " by email at …………... The Notice must (a) include your name, residence address, email address, and telephone number; (b) describe the nature and basis of the claim; and (c) set forth the specific relief sought. Our notice to you will be similar in form to that described above. If you and ",
                            constants/* PRODUCT_NAME */.sG,
                            " cannot reach an agreement to resolve the claim within thirty (30) days after such Notice is received, then either party may submit the Dispute to binding arbitration administered by SIAC or, under the limited circumstances set forth above, in court. All Disputes submitted to SIAC will be resolved through confidential, binding arbitration before one arbitrator. Arbitration proceedings will be held in Singapore, under the SIAC Arbitration Rules and Procedures (“SIAC Rules”). The most recent version of the SIAC Rules is available on the SIAC website and are hereby incorporated by reference. You either acknowledge and agree that you have read and understand the SIAC Rules or waive your opportunity to read the SIAC Rules and waive any claim that the SIAC Rules are unfair or should not apply for any reason."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "17.3 The arbitrator, ",
                            constants/* PRODUCT_NAME */.sG,
                            ", and you will maintain the confidentiality of any arbitration proceedings, judgments and awards, including all information gathered, prepared, and presented for purposes of the arbitration or related to the dispute(s) therein. The arbitrator will have the authority to make appropriate rulings to safeguard confidentiality unless the law provides to the contrary. The duty of confidentiality does not apply to the extent that disclosure is necessary to prepare for or conduct the arbitration hearing on the merits, in connection with a court application for a preliminary remedy or in connection with a judicial challenge to an arbitration award or its enforcement, or to the extent that disclosure is otherwise required by law or judicial decision."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "17.4 You and ",
                            constants/* PRODUCT_NAME */.sG,
                            " agree that for any arbitration, you will pay the filing fee and all other SIAC fees and costs. Any claim arising out of or related to these Terms or the Services must be filed within one (1) year after such claim arose; otherwise, the claim is permanently barred, which means that you and ",
                            constants/* PRODUCT_NAME */.sG,
                            " will not have the right to assert the claim."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "18. GOVERNING LAW"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                children: "The interpretation and enforcement of these Terms, and any Dispute related to these Terms or the Services, will be governed by and construed and enforced under the laws of the Singapore, as applicable, without regard to conflict of law rules or principles of any other jurisdiction) that would cause the application of the laws of any other jurisdiction. You agree that we may initiate a proceeding related to the enforcement or validity of our intellectual property rights in any court having jurisdiction."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h6",
                children: "19. MISCELLANEOUS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "19.1 You consent to receive all communications, agreements, documents, receipts, notices, and disclosures electronically (collectively, our “Communications”) that we provide in connection with these Terms or any Services. You agree that we may provide our Communications to you by posting them on the Site, by emailing them to you at the email address you provide in connection with using the Services, if any, or by Telegram at the username you provided to us during the course of your use of the Services. You should maintain copies of our Communications by printing a paper copy or saving an electronic copy."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "19.2 Any right or remedy of ",
                            constants/* PRODUCT_NAME */.sG,
                            " set forth in these Terms is in addition to, and not in lieu of, any other right or remedy whether described in these Terms, under Applicable Law, at law, or in equity. The failure or delay of ",
                            constants/* PRODUCT_NAME */.sG,
                            " in exercising any right, power, or privilege under these Terms will not operate as a waiver thereof."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "19.3 The invalidity or unenforceability of any of these Terms will not affect the validity or enforceability of any other of these Terms, all of which will remain in full force and effect."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "19.4 We will have no responsibility or liability for any failure or delay in performance of any of the Services, or any loss or damage that you may incur, due to any circumstance or event beyond our control, including any flood, extraordinary weather conditions, earthquake, or other act of God, fire, war, insurrection, riot, labor dispute, accident, action of government, communications, power failure, or equipment or software malfunction. You may not assign or transfer any right to use the Services, or any of your rights or obligations under these Terms, without our express prior written consent, including by operation of law or in connection with any change of control. We may assign or transfer any or all of our rights or obligations under these Terms, in whole or in part, with or without notice or obtaining your consent or approval."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "19.5 Except to the extent otherwise provided or unless the context otherwise requires, for the purposes of these Terms: (a) headings of sections are for convenience only and will not be used to limit or construe such sections; (b) whenever the words “include,” “includes” or “including” are used in these Terms, they are deemed to be followed by the words “without limitation”; and (c) the use of “or” is not intended to be exclusive."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            "19.6 These Terms contain the entire agreement between you and ",
                            constants/* PRODUCT_NAME */.sG,
                            ", and supersede all prior and contemporaneous understandings between the parties with respect to the Services."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "19.7 In the event of any conflict between these Terms and any other agreement you may have with us, these Terms will control unless such other agreement specifically identifies these Terms and declares that such other agreement supersedes these Terms."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "19.8 Any formal communication with you will, unless otherwise agreed, be made in the English language. In the event of any discrepancy between the English language version of the Terms or any such communications and any translation of the Terms or such communications (as applicable) in a foreign language, the respective English version shall prevail."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var terms_and_conditions_TermsAndConditionsEn = (TermsAndConditionsEn);

;// CONCATENATED MODULE: ./src/components/terms_and_conditions/index.tsx



const TermsAndConditions = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_and_conditions_TermsAndConditionsEn, {});
};
/* harmony default export */ var terms_and_conditions = (TermsAndConditions);

// EXTERNAL MODULE: ./src/layouts/index.tsx
var layouts = __webpack_require__(57836);
;// CONCATENATED MODULE: ./src/pages/terms-and-conditions/index.instantwire.tsx




const TermAndConditionPage = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* MainLayout */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_and_conditions, {})
    });
};
var __N_SSP = true;
/* harmony default export */ var index_instantwire = (TermAndConditionPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,7357,6571,3419,3595,2833,9774,2888,179], function() { return __webpack_exec__(19931); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);